<template>
  <div>
    <v-card
      id="participants-card"
      class="px-6"
      elevation="0"
      :disabled="disabled"
    >
      <v-card-title>
        Participants
      </v-card-title>
      <v-row
        justify="center"
        align="center"
      >
        <v-col>
          <SelectParticipants
            @inviteUser="handleInviteParticipant"
            :organizationUUID="organizationUUID"
            :type="'participants'"
          />
        </v-col>
      </v-row>
      <v-card-title>
        Facilitators
      </v-card-title>
      <v-row
        justify="center"
        align="center"
      >
        <v-col>
          <SelectParticipants
            @inviteUser="handleInviteFacilitator"
            :organizationUUID="organizationUUID"
            :type="'facilitators'"
          />
        </v-col>
      </v-row>
    </v-card>
    <!-- <v-dialog
      v-model="addUserDialog"
      width="500"
    >
      <InviteUserModal
        @close="() => { this.addUserDialog = false; this.addUserType = '' }"
        @response="(resp) => $emit('invite-response', resp)"
        :type="addUserType"
      />
    </v-dialog> -->
  </div>
</template>

<script>
import SelectParticipants from './SelectParticipants'
// import InviteUserModal from './InviteUserModal'

export default {
  name: 'ParticipantsPanel',

  props: ['disabled', 'organizationUUID'],

  components: {
    SelectParticipants
    // InviteUserModal
  },

  data: () => ({
    addUserDialog: false,
    addUserType: ''
  }),

  created () {

  },

  mounted () {
  },

  computed: {
  },

  methods: {
    handleInviteParticipant () {
      this.addUserDialog = true
      this.addUserType = 'Participant'
    },
    handleInviteFacilitator () {
      this.addUserDialog = true
      this.addUserType = 'Facilitator'
    }
  }
}
</script>

<style lang="sass" scoped>
  #participants-card
    width: 100%

  .participant
    margin: 10px

</style>
